// filepath: /Users/paulojustinchan/Downloads/workspace/PriveMD/achieve-admin-frontend/src/components/Loader/Loader.js
import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";

const Loader = ({ loader }) => {
    return (
        <>
            {loader.open && (
                <Box
                    sx={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "rgba(0, 0, 0, 0.4)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "top",
                        zIndex: 9999,
                    }}
                >
                    <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                    >
                        <CircularProgress />
                        <Typography variant="h6" sx={{ mt: 2, color: "white" }}>
                            {loader.message}
                        </Typography>
                    </Box>
                </Box>
            )}
        </>
    );
};

export default Loader;
